// 高德地图api
import axios from '@/utils/request'

// poi搜索
export function poiSearch (params) {
  return axios({
    url: '/platform/lbsmap/poi/search',
    method: 'get',
    params: params
  })
}
// 【高德】路线规划2.0-驾车,骑行,步行
export function routePlanning (params) {
  return axios({
    url: '/platform/publics/lbsmap/routePlanning',
    method: 'get',
    params: params
  })
}

// 通过经纬度查询位置
export function geotoLocation (params) {
  return axios({
    url: '/platform/publics/lbsmap/regeo',
    method: 'get',
    params: params
  })
}
